
import common from './common'
import dictionary from './dictionary'

export default{

    modules:{
        common,
        dictionary,
    }
}